import React from 'react';

export const ProcessSection = () => {
  const steps = [
    { number: '01', title: 'Get in Touch', desc: "Send me a message with the type of session you're looking for and your preferred date." },
    { number: '02', title: 'Plan Your Session', desc: 'We discuss the details and plan your session together — location, timing and outfits.' },
    { number: '03', title: 'Enjoy Your Session', desc: "Relax and enjoy the moment. I'll guide you throughout the session." },
    { number: '04', title: 'Your Photos', desc: 'Your edited images are delivered within 10 days via your private online gallery.' }
  ];

  return (
    <section className="section-spacing bg-[#121212]">
      <div className="revolt-container">
        <div className="text-center mb-lg">
          <h2 className="section-title">How It Works</h2>
        </div>
        
        <div className="process-grid">
          {steps.map((step, index) => (
            <div 
              key={`step-${step.number}`} 
              className={`process-step fade-in-up ${index > 0 ? `stagger-${index}` : ''}`}
            >
              <div className="process-number">{step.number}</div>
              <h3 className="process-title">{step.title}</h3>
              <p className="process-desc">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
